import './Draw.scss';
import moment from 'moment';
import localization from 'moment/locale/el'
import { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import store from '../../store';
import formSlice from '../form/formSlice';
import { useNavigate } from 'react-router-dom';
import analyzeSlice from '../analyze/analyzeSlice';
moment.locale('el', localization);

const Draw = (props) => {
  const navigate = useNavigate();

  function numberWithCommas(x) {
    var parts = x.toString().split(".");
    parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,".");
    return parts.join(",");
  }

  return (
    <div className="Draw">
      <div className="id">
        Κλήρωση {props.data.id}
      </div>

      <div className="info">
        <div className="date">
          <span>Ημερομηνία:</span>
          <span>{moment(props.data.date).format('dddd D MMMM')}</span>
        </div>
      </div>

      {
        true || props.data.status === 'results'
          ? <div className="results">
              <h2>Αποτελέσματα Κλήρωσης</h2>

              <div className="winning-numbers">
                {
                  props.data.winningNumbers.list.map((number, i) => {
                    return (
                      <div key={i}>{number}</div>
                    );
                  })
                }

                <div className="bonus">{props.data.winningNumbers.bonus[0]}</div>
              </div>
            </div>
          : ''
      }

      {
        props.data.status === 'active' && <div className="active-draw-message">
          <FontAwesomeIcon icon={faCalendar} size="lg" />
          <span>Αναμένονται αποτελέσματα {moment(props.data.date).fromNow()}</span>
        </div>
      }

      {
        props.data.winningNumbers && <Fragment>
          <button className="btn-process" onClick={() => {
            store.dispatch(formSlice.actions.updateNumbers(props.data.winningNumbers.list));
            navigate('/table');
          }}
          >
            Επεξεργασία
          </button>

          <button className="btn-process" onClick={() => {
            store.dispatch(analyzeSlice.actions.updateKeyNumbers(props.data.winningNumbers.list));
            navigate('/analyze');
          }}
          >
            Επεξεργασία ως κλειδιά
          </button>
        </Fragment>
      }
    </div>
  );
}

export default Draw;
